import React from 'react';
import { X } from 'lucide-react';

interface DateRangePickerProps {
  startDate: string;
  duration: number;
  onSelect: (startDate: string, duration: number) => void;
  onClose: () => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  duration,
  onSelect,
  onClose
}) => {
  const handleDateSelect = (date: string) => {
    onSelect(date, duration);
  };

  const handleDurationSelect = (months: number) => {
    onSelect(startDate || new Date().toISOString().split('T')[0], months);
  };

  return (
    <div className="p-4 min-w-[300px]">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-gray-900">When do you need it?</h3>
        <button 
          onClick={onClose}
          className="p-1.5 hover:bg-gray-100 rounded-full transition-colors"
        >
          <X className="h-5 w-5 text-gray-500" />
        </button>
      </div>

      {/* Date Input */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Start Date
        </label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => handleDateSelect(e.target.value)}
          min={new Date().toISOString().split('T')[0]}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
        />
      </div>

      {/* Duration Options */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Length of Stay
        </label>
        <div className="grid grid-cols-2 gap-2">
          {[
            { label: 'Flexible', value: 0 },
            { label: '1 Month', value: 1 },
            { label: '3 Months', value: 3 },
            { label: '6 Months', value: 6 }
          ].map((option) => (
            <button
              key={option.value}
              onClick={() => handleDurationSelect(option.value)}
              className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all ${
                duration === option.value
                  ? 'bg-indigo-600 text-white shadow-sm'
                  : 'bg-gray-50 text-gray-700 hover:bg-gray-100'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DateRangePicker;